import { useFormStore } from '@/stores/form'
import router from '@/router'
import { useGlobalStore } from '@/stores/global'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true',
    disableCardReader: true
  }
}

export default async function () {
  try {
    await initForm()
  } catch (error) {
    console.error('use905Preload', error)
  }
}
